'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createWixDataSchemas;
var WixDataSchemaApi = require('wix-data-schema-api');

function createWixDataSchemas(elementorySupportInstance) {
  return new WixDataSchemaApi(createWixDataSchemaApiProxy(elementorySupportInstance));
}

function createWixDataSchemaApiProxy(elementorySupportInstance) {
  return {
    get: function get() {
      return elementorySupportInstance.getJSON('/wix/schema-api-web.jsw/get.ajax', arguments);
    },
    list: function list() {
      return elementorySupportInstance.getJSON('/wix/schema-api-web.jsw/list.ajax', arguments);
    },
    save: function save() {
      return elementorySupportInstance.getJSON('/wix/schema-api-web.jsw/save.ajax', arguments);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-code-platform/lib/create-wix-data-schema-api.js
// module id = 257
// module chunks = 0